export class Tag {
    public key = '';
    public value = '';

    public removeLastSlash(): void {
        this.key = `${this.key ?? ''}`.replace(/\\$/, '');
        this.value = `${this.value ?? ''}`.replace(/\\$/, '');
    }

    public append(jumper: number, char: string): void {
        if (jumper === 0) {
            this.key += char;
        } else {
            this.value += char;
        }
    }

    public static escape(value: string): string {
        return value.replace(/:/g, '\\:').replace(/=/g, '\\=').replace(/;/g, '\\;').replace(/,/g, '\\,');
    }
}
